import React, { useState } from 'react';
import CommonModal from './CommonModal';
import { callAPI } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

const ACCEPTED_TYPES = 'image/jpeg,image/png,image/webp,application/pdf';

// Analysis genuinely takes a while (the file uploads, then Claude reads the whole page before
// replying) - callAPI's default axios timeout is fine for normal API calls but too short here, so
// this is passed through as an axios `options` override rather than relying on the default.
const ANALYZE_TIMEOUT_MS = 90000;

const FloorPlanImportModal = ({ isOpen, onClose, onAnalyzed }) => {
  const [file, setFile] = useState(null);
  const [analyzing, setAnalyzing] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    if (analyzing) return;
    setFile(null);
    setError('');
    onClose();
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0] || null);
    setError('');
  };

  const handleAnalyze = async () => {
    if (!file) return;
    setAnalyzing(true);
    setError('');
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await callAPI(apiUrls.FLOOR_PLAN_IMPORT_ANALYZE, {}, 'POST', formData, { timeout: ANALYZE_TIMEOUT_MS });
      onAnalyzed(res.data.data);
      setFile(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not analyze that file. Please try a clearer image or PDF.');
    } finally {
      setAnalyzing(false);
    }
  };

  return (
    <CommonModal isOpen={isOpen} onClose={handleClose} elId="floorPlanImportModal">
      <div className="modal-header">
        <h5 className="modal-title">Import Floor Plan</h5>
        <button className="btn-close" onClick={handleClose}></button>
      </div>

      <div className="modal-body">
        <p>
          Upload a photo or PDF of your existing floor plan. We'll do our best to detect tables and
          place them here for you to review and adjust - it won't be pixel-perfect, especially from
          a photo, but it should save you placing everything by hand.
        </p>
        <div className="mb-3">
          <input
            type="file"
            className="form-control"
            accept={ACCEPTED_TYPES}
            onChange={handleFileChange}
            disabled={analyzing}
          />
        </div>
        {error && <p className="text-danger">{error}</p>}
      </div>

      <div className="modal-footer justify-content-center">
        <button className="btn btn-secondary" onClick={handleClose} disabled={analyzing}>
          Cancel
        </button>
        <button className="btn btnPrimary" onClick={handleAnalyze} disabled={!file || analyzing}>
          {analyzing ? 'Analyzing...' : 'Analyze'}
        </button>
      </div>
    </CommonModal>
  );
};

export default FloorPlanImportModal;
